<template>
  <a
    v-tooltip="{
      content: tooltip,
      classes: 'badge-theme',
    }"
    :class="badgeClass"
  >
    <font-awesome-icon :icon="icon" />
    <template v-if="timeslot.start_from_time === '00:00:00'">
      {{ formatDate(timeslot.start_from, "DD MMM YYYY") }}
    </template>
    <template v-else>
      {{ formatDate(timeslot.start_from, "DD MMM YYYY@hh:mma") }}
    </template>
    -
    <template v-if="timeslot.end_by_time === '23:59:59'">
      {{ formatDate(timeslot.end_by, "DD MMM YYYY") }}
    </template>
    <template v-else>
      {{ formatDate(timeslot.end_by, "DD MMM YYYY@hh:mma") }}
    </template>
  </a>
</template>

<script type="text/babel">
import format from "../../mixins/format";

export default {
  mixins: [format],

  props: {
    tooltip: {
      default: null,
    },

    timeslot: {
      required: true,
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-light",
      icon: ["fal", "ban"],
    };
  },

  computed: {
    badgeClass() {
      return `badge badge-readable ${this.color} ${this.size}`;
    },
  },
};
</script>
